/* Love, P Organics — minimal vanilla JS for theme interactivity */
(function () {
  'use strict';

  // ----- Mobile menu toggle -----
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ----- FAQ accordion -----
  document.querySelectorAll('[data-faq-item]').forEach((item) => {
    const btn = item.querySelector('[data-faq-btn]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ----- Reveal on scroll -----
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );
    reveals.forEach((el) => obs.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('in'));
  }

  // ----- PDP gallery -----
  const thumbs = document.querySelectorAll('[data-pdp-thumb]');
  const main = document.querySelector('[data-pdp-main]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const url = thumb.getAttribute('data-image');
      if (main && url) main.src = url;
    });
  });

  // ----- PDP tabs -----
  document.querySelectorAll('[data-tab-group]').forEach((group) => {
    const tabs = group.querySelectorAll('[data-tab]');
    const panels = group.querySelectorAll('[data-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-tab');
        tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
        panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-panel') === id));
      });
    });
  });

  // ----- Quantity stepper -----
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const dec = wrap.querySelector('[data-qty-dec]');
    const inc = wrap.querySelector('[data-qty-inc]');
    if (!input) return;
    if (dec) dec.addEventListener('click', () => {
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (inc) inc.addEventListener('click', () => {
      const v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // ----- Cart drawer (Shopify AJAX cart) -----
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerCount = document.querySelectorAll('[data-cart-count]');
  const openCartBtns = document.querySelectorAll('[data-open-cart]');
  const closeCartBtns = document.querySelectorAll('[data-close-cart]');

  function openDrawer() { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  openCartBtns.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); refreshCart(); }));
  closeCartBtns.forEach((b) => b.addEventListener('click', closeDrawer));
  if (drawer) drawer.querySelector('.cart-drawer__backdrop')?.addEventListener('click', closeDrawer);

  function fmtMoney(cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD' }); }
    catch { return '$' + (cents / 100).toFixed(2); }
  }

  async function refreshCart() {
    if (!drawerBody) return;
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      drawerCount.forEach((el) => { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? '' : 'none'; });
      if (!cart.item_count) {
        drawerBody.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--primary" style="margin-top:20px">Continue shopping</a></div>';
        const foot = document.querySelector('[data-cart-drawer-foot]');
        if (foot) foot.style.display = 'none';
        return;
      }
      let html = '';
      cart.items.forEach((item) => {
        html += `<div class="cart-line" data-line-key="${item.key}">
          <div class="cart-line__img"><img src="${item.image || ''}" alt="${item.title}"></div>
          <div>
            <p class="cart-line__title">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${item.variant_title}</p>` : ''}
            <p class="cart-line__variant">Qty ${item.quantity}</p>
            <button type="button" class="cart-line__remove" data-remove="${item.key}">Remove</button>
          </div>
          <p class="cart-line__price">${fmtMoney(item.final_line_price)}</p>
        </div>`;
      });
      drawerBody.innerHTML = html;
      const foot = document.querySelector('[data-cart-drawer-foot]');
      if (foot) {
        foot.style.display = '';
        const sub = foot.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = fmtMoney(cart.total_price);
      }
      drawerBody.querySelectorAll('[data-remove]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const key = btn.getAttribute('data-remove');
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          refreshCart();
        });
      });
    } catch (e) { console.warn('Cart refresh failed', e); }
  }

  // Auto-open cart on Add To Cart form submit
  document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Add failed');
        await refreshCart();
        openDrawer();
      } catch (err) {
        console.warn(err); form.submit();
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      }
    });
  });

  // initial cart count
  refreshCart();
})();
